import aws from "assets/img/tech_stack/aws.png";
import azure from "assets/img/tech_stack/azure.png";
import gcp from "assets/img/tech_stack/gcp.png";

const textProps = {
  heading3: {
    title: "Cloud",
    alignment: "center",
  },

  infoAreas: [
    {
      image: aws,
      name: "Aws",
    },
    {
      image: azure,
      name: "Azure",
    },
    {
      image: gcp,
      name: "GCP",
    },
  ],
};
export default textProps;
